module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAMCAYAAABfnvydAAAAZ0lEQVQYlWPkOibOgARCoMw1MCEWJEkRBgaGqVD2QQYGhtcgBhOSgukMDAxiUDwNJghTEIJkPAof5AZRBgaGK1CdyOAVAwODLsgEkHHokiAAEpsKcmQokuB/KM2I7gacYMAVMDAwAAAdNgypw5xVtwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/up.png
// module id = XtJf
// module chunks = 1